import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class PersonalizedOfferService {
    static getOfferDataFromServer(currentPath, params, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('personalizedOffer'),
            'getPersonalizedOffer',
            [currentPath, params],
            additionalHeaders
        );
    }
}
